// import { json } from 'express';
import React, { Component } from 'react';


class ExamInstruction extends Component {
    state = {
        windowHeight: window.innerHeight - 60,
        error: null,
        loading: false,
        course: null,
        title: "",
        instruction: {},
        time: null,
        pass_score: null


    };
    fileInputRef = React.createRef();




    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            const formdisplay = document.querySelector(".dash_add_course_cover.examinstruction")
            formdisplay.style.display = "none"
        }

    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
        if (this.props.instruction !== null) {
            console.log("exam instruction mount:", this.props.instruction);
            this.setState({
                instruction: this.props.instruction
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.instruction !== prevProps.instruction) {
            this.setState({
                instruction: this.props.instruction || null
            },);
            console.log("instruction exam", this.props.instruction)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }


    handleResize = () => {
        this.setState({ width: "100%", windowHeight: window.innerHeight - 60 });
    };




    handleSubmit = (e) => {
        e.preventDefault();
        const { instruction } = this.state;
        // Save countdown time to localStorage
        localStorage.setItem("examCountDown", instruction.duration_minutes.toString());
        console.log(instruction.duration_minutes.toString())

        window.location.href = `/exam_question/${this.props.instruction.id}`; // Replace with your actual route

    }


    render() {
        const { instruction } = this.state
        const width = this.props.width
        console.log("insruction for exam", instruction)
        return (

            <div className={`dash_add_course_cover examinstruction ${width}`}
                style={{ height: width === "width" ? "100%" : this.state.windowHeight }}
            >
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Instruction</h2>
                    <p>Please specify the course for which you would like to create an exam</p>
                    <div className='point_container'>
                        <section className='container_point'>
                            <h5>
                                {instruction.num_questions}
                                <br />
                                <span>Question</span>
                            </h5>
                        </section>

                        <section className='container_point'>
                            <h5>
                                {instruction.duration_minutes}
                                <br />
                                <span>Duration(min)</span>
                            </h5>
                        </section>

                        <section className='container_point'>
                            <h5>
                                40%
                                <br />
                                <span>Pass Mark</span>
                            </h5>
                        </section>
                    </div>
                    <h4>Please Read !!</h4>
                    <p>{instruction.description}</p>
                    <p className='warning'>
                        No form of malpractice will be tolerated and if caught can lead to you failing the course
                    </p>
                    <form onSubmit={this.handleSubmit}>
                        <input type='checkbox' className='check' id='check' required /><label className='check'>To acknowlege you have read and you understand everything written</label>
                        <button style={{ margin: "10px 0px" }}>Start Exam</button>
                    </form>
                </div>
            </div>


        );
    }
}

export default ExamInstruction;